import { APP_ENVIRONMENT_CONSTANTS } from 'common/constants/appEnvironmentConstants'
import { env } from 'common/utils/env'

import { PATH_SEGMENT } from 'routes/pathSegments'

import { SIDEBAR_CONSTANTS } from './sidebar.constants'
import type { ISidebarTab } from './sidebar.types'

const guestBannedRoutes = [
  PATH_SEGMENT.STAFF,
  PATH_SEGMENT.PATIENTS,
  PATH_SEGMENT.SUPPORT,
  PATH_SEGMENT.SCHEDULE,
]
const unconfirmedDoctorBannedRoutes = [PATH_SEGMENT.PATIENTS]
const staffBannedRoutes = [PATH_SEGMENT.STAFF]

const CHARTS_HIDDEN_STAFF_IDS = [365] // this is a temporary solution, we need to implement permissions system in the future to handle this kind of cases [Ionut M.]

const config = {
  getItems: ({
    isGuest,
    isUnconfirmedDoctor,
    isSuperDoctor,
    isStaff,
    hasEmrEnabled,
    hasChartAccess,
    hasProfile,
    userId,
  }: {
    isGuest: boolean
    isUnconfirmedDoctor: boolean
    isSuperDoctor: boolean
    isStaff: boolean
    hasEmrEnabled: boolean
    hasChartAccess: boolean
    hasProfile: boolean
    userId?: number
  }): ISidebarTab[] => {
    const allItems: ISidebarTab[] = [
      {
        route: PATH_SEGMENT.HOME,
        title: SIDEBAR_CONSTANTS.HOME,
        icon: 'ph:house-line-light',
      },
      {
        route: PATH_SEGMENT.PROFILE,
        title: SIDEBAR_CONSTANTS.PROFILE,
        icon: 'ph:user',
      },
      {
        route: PATH_SEGMENT.SCHEDULE,
        title: SIDEBAR_CONSTANTS.SCHEDULE,
        icon: 'mingcute:schedule-line',
      },
      {
        route: PATH_SEGMENT.CHARTS,
        title: SIDEBAR_CONSTANTS.CHARTS,
        icon: 'ph:users-three-light',
      },
      {
        route: PATH_SEGMENT.STAFF,
        title: SIDEBAR_CONSTANTS.STAFF,
        icon: 'streamline:nurse-assistant-emergency',
      },
      {
        route: PATH_SEGMENT.PATIENTS,
        title: SIDEBAR_CONSTANTS.PATIENTS,
        icon: 'ph:users-three-light',
      },
      {
        route: PATH_SEGMENT.SUPPORT,
        title: SIDEBAR_CONSTANTS.SUPPORT,
        icon: 'ph:chats-circle',
      },

      {
        route: PATH_SEGMENT.FAQ,
        title: SIDEBAR_CONSTANTS.FAQ,
        icon: 'ph:rows',
      },
      {
        route: PATH_SEGMENT.ADMIN,
        title: SIDEBAR_CONSTANTS.ADMIN,
        icon: 'ph:shield-check-light',
      },
    ]

    return allItems.filter((item) => {
      if (isGuest && guestBannedRoutes.includes(item.route)) {
        return false
      }

      if (isUnconfirmedDoctor && unconfirmedDoctorBannedRoutes.includes(item.route)) {
        return false
      }

      if (isStaff && staffBannedRoutes.includes(item.route)) {
        return false
      }

      if (
        !hasProfile &&
        (item.route === PATH_SEGMENT.PATIENTS || item.route === PATH_SEGMENT.CHARTS)
      ) {
        return false
      }

      if (hasEmrEnabled && item.route === PATH_SEGMENT.PATIENTS) {
        return false
      }

      if ((!hasEmrEnabled || !hasChartAccess) && item.route === PATH_SEGMENT.CHARTS) {
        return false
      }

      if (
        userId !== undefined &&
        CHARTS_HIDDEN_STAFF_IDS.includes(userId) &&
        item.route === PATH_SEGMENT.CHARTS &&
        env.ENV === APP_ENVIRONMENT_CONSTANTS.PRODUCTION
      ) {
        return false
      }

      return !(!isSuperDoctor && item.route === PATH_SEGMENT.ADMIN)
    })
  },
}

export type SidebarConfigType = typeof config

export const sidebarConfig: SidebarConfigType = Object.freeze(config)
